import { Icon_default } from "./chunk-HALE5GZ6.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Spinner/Spinner.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var SPINNER_CLASSNAME_MAP = {
  variant: {
    primary: "pd:spinner--primary",
    dim: "pd:spinner--dim",
    white: "pd:spinner--white"
  },
  size: {
    sm: "pd:spinner--sm",
    md: "pd:spinner--md",
    lg: "pd:spinner--lg",
    xl: "pd:spinner--xl"
  }
};
var Spinner = forwardRef((_a, ref) => {
  var _b = _a,
    {
      variant = "primary",
      size = "md",
      screenReaderLabel,
      className
    } = _b,
    rest = __objRest(_b, ["variant", "size", "screenReaderLabel", "className"]);
  return /* @__PURE__ */jsx(Icon_default, __spreadValues({
    ref,
    icon: "spinner",
    className: clsx("pd:spinner", SPINNER_CLASSNAME_MAP.variant[variant], SPINNER_CLASSNAME_MAP.size[size], className),
    "aria-busy": "true",
    "aria-live": "polite",
    "aria-label": screenReaderLabel
  }, rest));
});
var Spinner_default = Spinner;
export { SPINNER_CLASSNAME_MAP, Spinner_default };